const mutations = {
  mutationInvoiceDetailQuotation(state, payload) {
    state.quotation = payload;
  },

  mutationInvoiceDetailQuotationList(state, payload) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.quotationList[payload.tab] = payload.responseData;
    } else {
      state.quotationList = payload;
    }
  },

  mutationInvoiceDetailQuotationListMeta(state, payload) {
    state.quotationListMeta = payload;
  },
};

export default mutations;
